import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

export function getAvatarInitials(name?: string | null, email?: string | null): string {
  const source = (name || email || '').trim();
  if (!source) return '?';

  const normalized = source.includes('@') ? source.split('@')[0] : source;
  const parts = normalized
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

interface UserAvatarProps {
  src?: string | null;
  name?: string | null;
  email?: string | null;
  className?: string;
  imageClassName?: string;
  fallbackClassName?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  src,
  name,
  email,
  className,
  imageClassName,
  fallbackClassName,
}) => {
  const displayName = name || email || 'User';

  return (
    <Avatar className={cn('border border-border bg-muted', className)}>
      {src && (
        <AvatarImage
          src={src}
          alt={`${displayName} avatar`}
          className={cn('object-cover', imageClassName)}
        />
      )}
      <AvatarFallback
        className={cn(
          'bg-gradient-to-br from-slate-900 to-slate-700 text-white font-semibold tracking-[-0.03em]',
          fallbackClassName
        )}
      >
        {getAvatarInitials(name, email)}
      </AvatarFallback>
    </Avatar>
  );
};
